import { INTEGRATION_META, IntegrationId } from '@/utilities/integration';
import { Box, SvgIconProps } from '@mui/material';

interface Props extends SvgIconProps {
  integrationId: IntegrationId;
  width?: number | string;
  linked?: boolean;
  /** Renders an amber needs-review dot on the icon's upper-right. */
  needsReview?: boolean;
}

/** Renders the appropriate integration icon based on integration ID */
export function IntegrationIcon(props: Props) {
  const {
    integrationId,
    linked = true,
    width,
    needsReview = false,
    ...svgProps
  } = props;
  const meta =
    integrationId !== 'NONE' ? INTEGRATION_META[integrationId] : undefined;
  if (meta === undefined) {
    return null;
  }
  const color = linked ? undefined : 'action';
  const icon = <meta.Icon color={color} width={width} {...svgProps} />;

  if (!needsReview) {
    return icon;
  }

  return (
    <Box
      component="span"
      sx={{ position: 'relative', display: 'inline-flex', lineHeight: 0 }}
    >
      {icon}
      <Box
        component="span"
        aria-hidden
        sx={(theme) => ({
          position: 'absolute',
          top: -3,
          right: -3,
          width: 12,
          height: 12,
          borderRadius: '50%',
          backgroundColor: 'warning.main',
          border: `2px solid ${theme.palette.background.paper}`,
          pointerEvents: 'none',
        })}
      />
    </Box>
  );
}
